// extracted by mini-css-extract-plugin
export default {"componentSelect":"ComponentsSidebar_componentSelect__9bLe-"};